"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var Common_module_css_1 = __importDefault(require("./Common.module.css"));
var Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
var CheckBoxOutlineBlank_1 = __importDefault(require("@mui/icons-material/CheckBoxOutlineBlank"));
var CheckIcon = function () { return (react_1.default.createElement("div", { className: "d-flex justify-content-center align-items-center ns-rounded-small ".concat(Common_module_css_1.default["checkbox-icon"]) },
    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCheck, style: {
            color: "var(--primary-color)",
        } }))); };
var EmptyBoxIcon = (react_1.default.createElement(CheckBoxOutlineBlank_1.default, { className: "ns-rounded-small ".concat(Common_module_css_1.default["checkbox-icon"]), style: {
        color: "transparent",
    } }));
var Checkbox = function (props) {
    return (react_1.default.createElement(Checkbox_1.default, __assign({ icon: EmptyBoxIcon, checkedIcon: react_1.default.createElement(CheckIcon, null) }, props)));
};
exports.default = Checkbox;
